// extracted by mini-css-extract-plugin
export var pin = "pins-module__pin___CD9rp";